




























import { defineComponent } from '@nuxtjs/composition-api';
import SfButton from './SfButton/SfButton.vue';

export default defineComponent({
  name: 'SfScrollable',
  components: {
    SfButton,
  },
  props: {
    maxContentHeight: {
      type: String,
      default: '',
    },
    showText: {
      type: String,
      default: 'Show',
    },
    hideText: {
      type: String,
      default: 'Hide',
    },
  },
  data() {
    const calcMaxHeight = (isHidden) => {
      let maxHeight = '5rem';
      if (this.maxContentHeight.trim() && isHidden) {
        maxHeight = this.maxContentHeight;
      } else if (!isHidden) {
        maxHeight = '100%';
      }
      return maxHeight;
    };

    return {
      isHidden: true,
      hasScroll: false,
      calcMaxHeight,
    };
  },
  computed: {
    style(this: { isHidden: boolean; calcMaxHeight: any }) {
      return {
        'max-height': this.calcMaxHeight(this.isHidden),
      };
    },
  },
});
